export default __webpack_public_path__ + "static/hippo_batteries-e4ee88299971ac75b35decd46e59bda4.jpg";